import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react'

type BeforeInstallPromptEvent = Event & {
  readonly platforms: Array<string>

  prompt(): Promise<void>

  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed'
    platform: string
  }>
}

type BeforeInstallPromptContextType = {
  beforeInstallPromptEvent: BeforeInstallPromptEvent | null
  reset: () => void
}

const beforeInstallPromptContext = createContext<BeforeInstallPromptContextType>(undefined!)

export const useBeforeInstallPromptContext = () => useContext(beforeInstallPromptContext)

export const BeforeInstallPromptProvider = ({ children }: PropsWithChildren) => {
  const [installPromptEvent, setInstallPromptEvent] = useState<BeforeInstallPromptEvent | null>(null)

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', event => {
      event.preventDefault()
      setInstallPromptEvent(event as BeforeInstallPromptEvent)
    })
  }, [])

  return (
    <beforeInstallPromptContext.Provider
      value={{ beforeInstallPromptEvent: installPromptEvent, reset: () => setInstallPromptEvent(null) }}
    >
      {children}
    </beforeInstallPromptContext.Provider>
  )
}
